var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"sort-field",attrs:{"value":_vm.value,"items":_vm.items,"menu-props":{
    offsetY: true,
    closeOnClick: true,
    contentClass: 'rounded-0',
  },"hide-details":"","outlined":"","dense":""},on:{"change":_vm.onChangeValue},scopedSlots:_vm._u([{key:"selection",fn:function({ item }){return [_c('span',{staticClass:"blue-grey--text text-truncate"},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }